import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 gradient-hero">
      <div className="glass rounded-3xl p-10 max-w-md w-full text-center fade-up" data-testid="payment-cancel">
        <div className="w-16 h-16 rounded-full bg-slate-700/30 border border-slate-600 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-9 h-9 text-slate-400" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-white">Checkout cancelled</h1>
        <p className="text-slate-400 mt-2 text-sm">No worries — your card was not charged. The listing is still available whenever you're ready.</p>
        <Link to="/browse" className="inline-flex items-center gap-2 mt-7 btn-neon rounded-full px-7 py-3 font-semibold">
          <ArrowLeft className="w-4 h-4" /> Keep exploring
        </Link>
      </div>
    </div>
  );
}
